<template>
  <div data-testid="AddPoints">
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Add
      <select
        :value="amountOrBalance"
        name="amountOrBalance"
        class="form-control"
        @change="handleChange"
      >
        <option value="amount">
          Amount:
        </option>
        <option value="balance">
          Total Point Balance
        </option>
      </select>

      <template v-if="amountOrBalance === 'amount'">
        <span :class="{'has-error':errors.addPointValue}">
          <input
            :value="addPointValue"
            class="form-control input-numeric"
            name="addPointValue"
            @input="handleChange"
          >
          points
        </span>
      </template>
    </div>
    <div>
      <input
        :checked="onlyAddPointsOnce"
        type="checkbox"
        name="onlyAddPointsOnce"
        @change="handleChange"
      >
      Only add points once
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      amountOrBalance: {
        default: 'amount'
      },
      addPointValue: {},
      onlyAddPointsOnce: {
        default: true
      },
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (this.amountOrBalance === 'amount') {
          if (!this.isNumber(this.addPointValue) || this.addPointValue < 0) {
            this.errors.addPointValue = "Please enter a positive amount of points to add.";
          }
        }
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
